import { Box, Collapse, IconButton, List, ListItem, ListItemText, Paper, Stack, Typography } from '@mui/material'
import React, { useState } from 'react'
import { getVisualTimer } from '../../sports/rules.js'
import PushPinIcon from '@mui/icons-material/PushPin';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const RecapQuizz = ({quizz, match}) => {

    const {timer, period, isPin, displayDate, creation} = quizz

    // Gestion de l'état d'expansion pour chaque choix
    const [expandedChoice, setExpandedChoice] = useState(null);

    const handleToggle = (choiceIndex) => {
        setExpandedChoice(expandedChoice === choiceIndex ? null : choiceIndex);
    };

    return (
        <div>
        {/*<img src={undefined} width="60px"/>*/}
        <Box>
            <Paper
            sx={{
                padding: 2,
                marginBottom: 2,
                backgroundColor: '#f9f9f9',
                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                borderRadius: '15px',
            }}
            >

             {/* Titre du quiz */}
          {match.idMatch && (
            <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: 1 }}>
              Quiz
            </Typography>
          )}

          {/* Question du quiz */}
          <Typography variant="subtitle1" gutterBottom sx={{ fontStyle: 'italic', color: '#555' }}>
            {quizz.question}
          </Typography>

          {/* Liste des choix du quiz */}
          <List sx={{ padding: 0 }}>
            {quizz.choices.map((choice, choiceIndex) => (
              <div key={`${choice.label}-${choiceIndex}`}>
                <ListItem
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '10px',
                    marginBottom: '0',
                    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                    borderRadius: '12px',
                    backgroundColor: '#ffffff',
                    border: `1px solid #ccc`,
                    cursor: 'pointer'
                  }}
                  onClick={() => handleToggle(choiceIndex)}
                >
                  <ListItemText
                    primary={choice.entries.length === 1 ? choice.entries[0].name : `${choice.label}`}
                    sx={{ color:  '#333' }}
                  />
                  <IconButton>
                    {expandedChoice === choiceIndex ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  </IconButton>
                </ListItem>

                {/* Affichage des choix lorsque l'utilisateur clique */}
                <Collapse in={expandedChoice === choiceIndex} timeout="auto" unmountOnExit>
                  <Box sx={{ padding: '10px 20px', backgroundColor: '#f5f5f5', borderRadius: '0 0 12px 12px' }}>
                    {choice.entries.map((entry) => (
                      <Typography key={entry.id} variant="body2" sx={{ marginBottom: '5px', borderBottom: '1px dashed #00000021'}}>
                        {entry.name}
                      </Typography>
                    ))}
                  </Box>
                </Collapse>
              </div>
            ))}
          </List>
        </Paper>
      </Box>

       {/* Match minute if applicable */}
       {match.idMatch && (timer !== 0 || period !== 0) && (
        <Typography>Minute : {getVisualTimer(period, timer / 60, match.discipline)}</Typography>
      )}

      {/* Display if pinned */}
      {isPin && (
        <Typography variant="body1" color="primary" sx={{ marginTop: 1 }}>
          <PushPinIcon fontSize="small" style={{ marginRight: 4, color: 'black' }} />
          Ce sondage est épinglé
        </Typography>
      )}

      {/* Display Date */}
      {displayDate ? (
        <Typography variant="body2" sx={{ marginTop: 1 }}>
          Publié le : {new Date(displayDate).toLocaleDateString()} à {new Date(displayDate).toLocaleTimeString()}
        </Typography>
      ) : (
        <Typography variant="body2" sx={{ marginTop: 1 }}>
          Publié le : {new Date(creation).toLocaleDateString()} à {new Date(creation).toLocaleTimeString()}
        </Typography>
      )}

           {/* {quizz.choices.map((choice, idx) => (
                <Stack key={idx} variant="subtitle1" gutterBottom>
                {choice.entries.length === 1
                    ? choice.entries[0].name
                    : `${choice.label}: ${choice.entries.length} choix`}
                </Stack>
           ))} */}

      {/*  {(timer !== 0 || period !== 0) && <Typography>Minute : {getVisualTimer(period, timer/60, match.discipline)}</Typography>} */}
        </div>
    )
}

export default RecapQuizz